import React, { useEffect, useRef, useState } from "react";
import { GrMoreVertical } from "react-icons/gr";
import Pagination from "../../components/pagination/pagination";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/button/button";
import { domainName } from "../../components/data/domainName";
import {
    deleteGlossaryAction,
    glossaryListAction,
    translationMemoryDeleteAction,
    translationMemoryEnableDisableAction,
    translationMemoryListAction,
} from "../../redux/actions/resourceAction";
import { useDispatch, useSelector } from "react-redux";
import errorToast from "../../components/toasts/errorToast";
import { availableLanguages } from "../../components/data/languageData";
import moment from "moment";
import successToast from "../../components/toasts/successToast";
import ReactSelectFiled from "../../components/forms/reactSelect";
import CustomCheckboxDropdown from "../../components/forms/checkBoxDropDown";
import { getLangName } from "../../components/helper";
import { getSignedUrlAction } from "../../redux/actions/translationAction";
import TranslationMemory from "../../components/resources/translationMemory";
import { useAuth } from '../../context/AuthContext';

export const Resources = () => {
    const userDetails = useSelector((store) => store?.userReducer?.data);
    const { isAdmin } = useAuth();
    const [filteredData, setFilteredData] = useState([]);
    const [name, setName] = useState("");
    const [domian, setDomian] = useState("");
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("");
    const [langFilter, setLangFilter] = useState([]);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationData, setPaginationData] = useState({});
    const [showOptions, setShowOptions] = useState(false);
    const [showClearIndex, setShowClearIndex] = useState(null);

    const [tmFilteredData, setTmFilteredData] = useState([]);
    const [tmName, setTmName] = useState("");
    const [tmStartDate, setTmStartDate] = useState("")
    const [tmEndDate, setTmEndDate] = useState("");
    const [tmLangFilter, setTmLangFilter] = useState([]);
    const [tmFiltersApplied, setTmFiltersApplied] = useState(false);
    const [tmLoading, setTmLoading] = useState(true);
    const [tmPage, setTmPage] = useState(1);
    const [tmRowsPerPage, setTmRowsPerPage] = useState(10);
    const [tmPaginationData, setTmPaginationData] = useState({});
    const [tmShowOptions, setTmShowOptions] = useState(false);
    const [tmShowClearIndex, setTmShowClearIndex] = useState(null);

    const [checked, setChecked] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        setChecked(userDetails?.company?.is_translationMemory)
        setTmLoading(false)
    }, [userDetails])

    const handleApplyFilters = () => {
        setLoading(true);
        setFiltersApplied(true); // Show the table after filters are applied
        dispatch(glossaryListAction({
            page,
            page_size: rowsPerPage,
            name: name,
            domain: domian,
            lang: langFilter,
            from_date: startDate,
            to_date: endDate,
        }, onSuccess, onError));
    };

    const handleTmApplyFilters = () => {
        setLoading(true);
        setTmFiltersApplied(true); // Show the table after filters are applied
    };

    // Function to fetch all records without filters
    const handleGetAllRecords = () => {
        setLoading(true);
        setName('');
        setDomian('');
        setLangFilter([]);
        setStartDate('');
        setEndDate('');
        setFiltersApplied(true); // Show the table
        dispatch(glossaryListAction({ page, page_size: rowsPerPage }, onSuccess, onError)); // No filters
    };

    // Function to fetch all records without filters
    const handleGetAllTmRecords = () => {
        setTmLoading(true);
        setTmName('');
        setTmLangFilter([]);
        setTmStartDate('');
        setTmEndDate('');
        setTmFiltersApplied(true); // Show the table
        dispatch(translationMemoryListAction({ page, page_size: tmRowsPerPage }, onTmlistSuccess, onError)); // No filters
    };

    const handleClear = () => {
        setLoading(false);
        setName('');
        setDomian('');
        setLangFilter([]);
        setStartDate('');
        setEndDate('');
        setFiltersApplied(false);
    };

    const handleTmClear = () => {
        setTmLoading(false);
        setTmName('');
        setTmLangFilter([]);
        setTmStartDate('');
        setTmEndDate('');
        setTmFiltersApplied(false);
    };

    useEffect(() => {
        if (filtersApplied) {
            setLoading(true);
            dispatch(
                glossaryListAction(
                    {
                        page, page_size: rowsPerPage,
                        name: name,
                        domain: domian,
                        lang: langFilter,
                        from_date: startDate,
                        to_date: endDate,
                    },
                    onSuccess,
                    onError
                )
            );
        }
    }, [page, rowsPerPage, domian, name, langFilter, startDate, endDate, filtersApplied, dispatch]);

    useEffect(() => {
        if (tmFiltersApplied) {
            setTmLoading(true);
            dispatch(
                translationMemoryListAction(
                    {
                        page: tmPage,
                        page_size: tmRowsPerPage,
                        name: tmName,
                        lang: tmLangFilter,
                        from_date: tmStartDate,
                        to_date: tmEndDate,
                    },
                    onTmlistSuccess,
                    onError
                )
            );
        }
    }, [tmPage, tmRowsPerPage, tmName, tmLangFilter, tmStartDate, tmEndDate, tmFiltersApplied, dispatch]);

    const onSuccess = (data) => {
        setPaginationData(data?.data?.data?.pagination);
        setFilteredData(data?.data?.data?.glossaries);
        setLoading(false);
    };

    const onTmlistSuccess = (data) => {
        setTmPaginationData(data?.data?.data?.pagination);
        setTmFilteredData(data?.data?.data?.translationMemories);
        setTmLoading(false);
    };

    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    const handleMoreOptionsClick = (item, index) => {
        setShowClearIndex(index);
        setShowOptions(!showOptions);
    };

    const handleTmMoreOptionsClick = (item, index) => {
        setTmShowClearIndex(index);
        setTmShowOptions(!tmShowOptions);
    };

    const getDomainLabel = (value) => {
        const domain = domainName.find((domain) => domain.value === value);
        return domain ? domain.label : "--";
    };

    const handleDeleteClick = (id) => {
        setLoading(true);
        dispatch(deleteGlossaryAction({ id }, onDeleteSuccess, onError));
    };

    const handleTmDeleteClick = (id) => {
        setLoading(true);
        dispatch(translationMemoryDeleteAction({ id }, onTmDeleteSuccess, onError));
    };

    const handleToggle = () => {
        setLoading(true);
        dispatch(translationMemoryEnableDisableAction({}, onToggleSuccess, onError));
    };

    const onToggleSuccess = (data) => {
        successToast(data?.data?.message);
        setChecked(!checked);
    };

    const onDeleteSuccess = (data) => {
        dispatch(
            glossaryListAction(
                {
                    page,
                    page_size: rowsPerPage,
                    name: name,
                    domain: domian,
                    lang: langFilter,
                    from_date: startDate,
                    to_date: endDate,
                },
                onSuccess,
                onError
            )
        );
        setShowOptions(false);
        setShowClearIndex(null);
        successToast(data?.data?.message);
    };

    const onTmDeleteSuccess = (data) => {
        if (tmFiltersApplied) {
            setTmLoading(true);
            dispatch(
                translationMemoryListAction(
                    {
                        page: tmPage,
                        page_size: tmRowsPerPage,
                        name: tmName,
                        lang: tmLangFilter,
                        from_date: tmStartDate,
                        to_date: tmEndDate,
                    },
                    onTmlistSuccess,
                    onError
                )
            );
        }
        setTmShowOptions(false);
        setTmShowClearIndex(null);
        successToast(data?.data?.message);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowOptions(false);
            setShowClearIndex(null);
            setTmShowClearIndex(null);
            setTmShowOptions(false)
        }

        if (checkboxDropdownRef.current && !checkboxDropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }

        if (checkboxTmDropdownRef.current && !checkboxTmDropdownRef.current.contains(event.target)) {
            setTmDropdownOpen(false);
        }
    };

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [tmDropdownOpen, setTmDropdownOpen] = useState(false);
    const checkboxDropdownRef = useRef(null);
    const checkboxTmDropdownRef = useRef(null);

    const downloadFile = (fileUrl) => {
        const link = document.createElement('a');
        link.href = fileUrl;

        // Optional: Extract filename from URL
        const fileName = fileUrl.split('/').pop();
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const downloadGlossaryFile = (fileUrl) => {
        dispatch(getSignedUrlAction({ fileUrl: fileUrl },
            (data) => {
                const link = document.createElement('a');
                link.href = data?.data?.data;

                // Optional: Extract filename from URL
                const fileName = fileUrl.split('/').pop();
                link.download = fileName;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            onError))
    }

    return (
        <div className="vh-100 overflow-auto" onClick={handleClickOutside}>
            <div className="w-100 z-1 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2 justify-content-between">
                <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">
                    Resources
                </h2>
                <CustomButton
                    className="cursor_pointer fs_18 pb-1 mx-3 d-flex align-items-center justify-content-center"
                    style={{ height: "35px", width: "157px" }}
                    variant="primary"
                    onClick={() => navigate("/add-resources")}
                >
                    + ADD RESOURCE
                </CustomButton>
            </div>
            <div className="w-100">
                <section id="glossaries">
                    <h4 className="text-start mt-2 mx-3 fw_400">Glossaries</h4>
                    <p className="text-start mx-3">Glossaries are custom dictionaries that help you consistently translate terms and named entities.</p>
                    <div className='d-flex flex-wrap gap-3 px-3 pb-3'>
                        <div className='text-start'>
                            <span className="">Glossary Name</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='text'
                                    name='name'
                                    className='input-field w-100'
                                    placeholder="Enter glossary name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='text-start' style={{ width: '14rem' }}>
                            <ReactSelectFiled
                                onChange={(value) => setDomian(value)}
                                options={domainName}
                                label="Domain"
                                value={domian}
                            />
                        </div>


                        <div className="text-start text-nowrap" ref={checkboxDropdownRef} style={{ maxWidth: '14rem' }}>
                            <label htmlFor={`target_lang`} className="">Language</label>
                            <div className="custom-dropdown">
                                <CustomCheckboxDropdown
                                    options={availableLanguages}
                                    name={"languages"}
                                    value={langFilter}
                                    onChange={(field, value) => setLangFilter(value)}
                                    placeholder={'Select Languages'}
                                    dropdownOpen={dropdownOpen}
                                    setDropdownOpen={setDropdownOpen}
                                    width="14rem"
                                />
                            </div>
                        </div>

                        <div className='text-start'>
                            <span className="">From Date</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='date'
                                    name='startDate'
                                    className='input-field w-100'
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                        </div>

                        <div className='text-start'>
                            <span className="">To Date</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='date'
                                    name='endDate'
                                    className='input-field w-100'
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-wrap justify-content-start gap-3 mx-3 text-nowrap">
                        <CustomButton variant="primary" onClick={handleApplyFilters} disabled={!domian && !name && !startDate && !endDate && langFilter.length === 0} >
                            Apply Filters
                        </CustomButton>
                        <CustomButton variant="primary" onClick={handleGetAllRecords}>
                            Show All
                        </CustomButton>
                        <CustomButton variant="secondary" onClick={handleClear}>
                            Clear Filters
                        </CustomButton>
                    </div>
                    {filtersApplied && (
                        <>
                            <div className="m-3 overflow-auto">
                                <div
                                    className="table-responsive"
                                    style={{ minWidth: "100%" }}
                                >
                                    <table className="table table-bordered">
                                        <thead className="table-light">
                                            <tr className="text-start text-nowrap">
                                                <th width={"8%"} className="fw_400">
                                                    Sl No.
                                                </th>
                                                <th width={"18%"} className="fw_400">
                                                    Glossary Name
                                                </th>
                                                <th width={"18%"} className="fw_400">
                                                    Domain
                                                </th>
                                                <th width={"18%"} className="fw_400">
                                                    Language Set
                                                </th>
                                                <th width={"18%"} className="fw_400">
                                                    Create Date
                                                </th>
                                                <th width={"35%"} className="fw_400">
                                                    Last Updated
                                                </th>
                                                {isAdmin && <th></th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="7">loading...</td>
                                                </tr>
                                            ) : filteredData?.length > 0 ? (
                                                filteredData?.map((item, index) => (
                                                    <tr key={index} className="text-start">
                                                        <td>{index + 1}</td>
                                                        <td>{item.name}</td>
                                                        <td>{getDomainLabel(item?.domain)}</td>
                                                        <td>
                                                            {item?.language_set
                                                                ?.map((lang) => `${getLangName(lang)} (${lang})`)
                                                                .join(", ")}
                                                        </td>
                                                        <td>
                                                            {moment(item?.createdAt).format("MM/DD/YY, hh:mm A")}
                                                        </td>
                                                        <td>
                                                            {moment(item?.updatedAt).format("MM/DD/YY, hh:mm A")}
                                                        </td>
                                                        {isAdmin && (
                                                            <td>
                                                                <GrMoreVertical
                                                                    className="cursor_pointer"
                                                                    onClick={() => handleMoreOptionsClick(item, index)}
                                                                />
                                                                {showOptions && showClearIndex === index && (
                                                                    <div
                                                                        className="position-relative"
                                                                        ref={dropdownRef}
                                                                    >
                                                                        <div
                                                                            className="position-absolute"
                                                                            style={{ left: "-5rem" }}
                                                                        >
                                                                            <div className="card" style={{ width: "5rem" }}>
                                                                                <div className="card-body p-2">
                                                                                    <label
                                                                                        className="d-block text-danger cursor_pointer hover-effect"
                                                                                        onClick={() => {
                                                                                            handleDeleteClick(item.id);
                                                                                        }}
                                                                                    >
                                                                                        Delete
                                                                                    </label>
                                                                                    <label
                                                                                        className="d-block cursor_pointer hover-effect"
                                                                                        onClick={() => {
                                                                                            downloadGlossaryFile(item.file_url);
                                                                                        }}
                                                                                    >
                                                                                        Export
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7">No rows to display</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="mx-4 pb-3 d-flex justify-content-end">
                                {!loading &&
                                    <Pagination
                                        data={paginationData}
                                        nextFunc={() => setPage(page + 1)}
                                        prevFunc={() => setPage(page - 1)}
                                        setPageRowFunc={(value) => {
                                            setPage(1);
                                            setRowsPerPage(value);
                                        }}
                                    />
                                }
                            </div>
                        </>
                    )}
                </section>

                <TranslationMemory />

                {/* <section id="translation-memories" className="mt-5">
                    <div className="d-flex justify-content-start align-items-center mt-4 w-fit">
                        <h5 className="text-start mt-1 mx-3 fs_20 fw_400 fn_Roboto">Translation Memories</h5>
                        {userDetails?.user_type === "admin" &&
                            <div className="d-flex align-items-center gap-2">
                                <div
                                    className={`custom-toggle ${checked ? "on" : "off"}`}
                                    onClick={handleToggle}
                                    role="button"
                                    aria-pressed={checked}
                                >
                                    <div className="toggle-knob" />
                                </div>
                                <span className="fw-bold">{checked ? "ON" : "OFF"}</span>
                            </div>
                        }
                    </div>


                    <p className="text-start mx-3 mt-2">Translation memories store human-reviewed sentence pairs. Users can apply a translation memory on their translations and any matching source sentences are replaced by the human-reviewed translations.</p>
                    <div className='d-flex flex-wrap gap-3 px-3 pb-3'>

                        <div className="text-start text-nowrap" ref={checkboxTmDropdownRef} style={{ maxWidth: '14rem' }}>
                            <label htmlFor={`target_langugaes`} className="">Language</label>
                            <div className="custom-dropdown">
                                <CustomCheckboxDropdown
                                    key="tmemories"
                                    options={availableLanguages}
                                    name={"tm_languages"}
                                    value={tmLangFilter}
                                    onChange={(field, value) => setTmLangFilter(value)}
                                    placeholder={'Select Languages'}
                                    dropdownOpen={tmDropdownOpen}
                                    setDropdownOpen={setTmDropdownOpen}
                                    width="14rem"
                                    disabled={!checked}
                                />
                            </div>
                        </div>

                        <div className='text-start'>
                            <span className="">From Date</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='date'
                                    name='startDate'
                                    className='input-field w-100'
                                    value={tmStartDate}
                                    onChange={(e) => setTmStartDate(e.target.value)}
                                    max={new Date().toISOString().split('T')[0]}
                                    disabled={!checked}
                                />
                            </div>
                        </div>

                        <div className='text-start'>
                            <span className="">To Date</span>
                            <div className='' style={{ width: '14rem' }}>
                                <input
                                    type='date'
                                    name='endDate'
                                    className='input-field w-100'
                                    value={tmEndDate}
                                    onChange={(e) => setTmEndDate(e.target.value)}
                                    max={new Date().toISOString().split('T')[0]}
                                    disabled={!checked}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-wrap justify-content-start gap-3 mx-3 text-nowrap">
                        <CustomButton variant="primary" onClick={handleTmApplyFilters} disabled={!tmName && !tmStartDate && !tmEndDate && tmLangFilter.length === 0} >
                            Apply Filters
                        </CustomButton>
                        <CustomButton variant="primary" onClick={handleGetAllTmRecords} disabled={!checked} >
                            Show All
                        </CustomButton>
                        <CustomButton variant="secondary" onClick={handleTmClear} disabled={!checked}>
                            Clear Filters
                        </CustomButton>
                    </div>

                    {tmFiltersApplied && (
                        <>
                            <div className="m-3 overflow-auto">
                                <div
                                    className="table-responsive"
                                    style={{ minHeight: "26rem", minWidth: "100%" }}
                                >
                                    <table className="table table-bordered">
                                        <thead className="table-light">
                                            <tr className="text-start text-nowrap">
                                                <th width={"5%"} className="fw_400">
                                                    Sl No.
                                                </th>
                                                <th width={"30%"} className="fw_400">
                                                    Resource Name
                                                </th>
                                                <th width={"35%"} className="fw_400">
                                                    Language Set
                                                </th>
                                                <th width={"15%"} className="fw_400">
                                                    Create Date
                                                </th>
                                                <th width={"15%"} className="fw_400">
                                                    Last Updated
                                                </th>
                                                {isAdmin && <th></th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tmLoading ? (
                                                <tr>
                                                    <td colSpan="7">loading...</td>
                                                </tr>
                                            ) : tmFilteredData?.length > 0 ? (
                                                tmFilteredData?.map((item, index) => (
                                                    <tr key={index} className="text-start">
                                                        <td>{index + 1}</td>
                                                        <td>{item.glossary_name}</td>
                                                        <td>
                                                            {getLangName(item?.source_lang) + " → " + getLangName(item?.target_lang)}
                                                        </td>
                                                        <td>
                                                            {moment(item?.createdAt).format("MM/DD/YY, hh:mm A")}
                                                        </td>
                                                        <td>
                                                            {moment(item?.updatedAt).format("MM/DD/YY, hh:mm A")}
                                                        </td>
                                                        {isAdmin && (
                                                            <td>
                                                                <GrMoreVertical
                                                                    className="cursor_pointer"
                                                                    onClick={() => handleTmMoreOptionsClick(item, index)}
                                                                />
                                                                {tmShowOptions && tmShowClearIndex === index && (
                                                                    <div
                                                                        className="position-relative"
                                                                        ref={dropdownRef}
                                                                    >
                                                                        <div
                                                                            className="position-absolute"
                                                                            style={{ left: "-5rem" }}
                                                                        >
                                                                            <div className="card" style={{ width: "5rem" }}>
                                                                                <div className="card-body p-2">
                                                                                    <label
                                                                                        className="d-block text-danger cursor_pointer hover-effect"
                                                                                        onClick={() => {
                                                                                            handleTmDeleteClick(item.id);
                                                                                        }}
                                                                                    >
                                                                                        Delete
                                                                                    </label>
                                                                                    <label
                                                                                        className="d-block cursor_pointer hover-effect"
                                                                                        onClick={() => {
                                                                                            downloadFile(item.file_url);
                                                                                        }}
                                                                                    >
                                                                                        Export
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7">No rows to display</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="mx-4 pb-3 d-flex justify-content-end">
                                {!tmLoading &&
                                    <Pagination
                                        data={tmPaginationData}
                                        nextFunc={() => setTmPage(page + 1)}
                                        prevFunc={() => setTmPage(page - 1)}
                                        setPageRowFunc={(value) => {
                                            setTmPage(1);
                                            setTmRowsPerPage(value);
                                        }}
                                    />
                                }
                            </div>
                        </>
                    )}
                </section> */}
            </div>
        </div >
    );
};
